import React from 'react';
import MarketSummary from './Components/MarketSummary';
import CommercialYearsTable from './Components/CommercialYearsTable';
import LastYearSummay from './Components/LastYearSummary';
import { Typography } from '@mui/material';

const SiiComercialYears = (props: any) => {
  const { response, searched } = props;
  const { commercialYearsSummary, marketSummary, UF } = response;
  if (commercialYearsSummary.length === 0) {
    return (
      <>
        <Typography variant="h6" fontWeight={600}>
          SII - Años comerciales
        </Typography>
        <Typography>No hay datos</Typography>
      </>
    );
  }
  const lastYear = commercialYearsSummary.sort(
    (a: any, b: any) => b.year - a.year,
  )[0];
  return (
    <>
      <Typography variant="h6" fontWeight={600}>
        SII - Años comerciales
      </Typography>
      <div>
        <LastYearSummay commercialYearSummary={lastYear} />
      </div>
      <MarketSummary data={marketSummary} uf={UF} />
      <div></div>
      {searched && <CommercialYearsTable data={commercialYearsSummary} />}
    </>
  );
};

export default SiiComercialYears;
